import {useCallback, useEffect} from 'react';
import {SESSION_TIMEOUT_MS} from '../constants/app-constants';

const events: (keyof DocumentEventMap)[] = [
  'mousedown',
  'keydown',
  'mousemove',
  'touchmove'
];

let sessionTimeout: NodeJS.Timeout;

export default function useSessionExpire(onExpire: () => void): () => void {

  const startTimeoutTimer = useCallback((): void => {
    clearTimeout(sessionTimeout);
    sessionTimeout = setTimeout(onExpire, SESSION_TIMEOUT_MS);
  }, []);

  useEffect(() => {
    events.forEach((event) => document.addEventListener(event, startTimeoutTimer, {passive: true}));

    return () => {
      clearTimeout(sessionTimeout);
      events.forEach((event) => document.removeEventListener(event, startTimeoutTimer, true));
    };
  }, [startTimeoutTimer]);

  return startTimeoutTimer;
}
